$(document).ready(function(){
    // Set slide animation classes
    $slide_elements = $('.slide-up, .slide-in-left, .slide-in-right');

    // Hide all elements on the page initially
    $.each($slide_elements, function() {
        $(this).addClass('hide');
    });

    // Check if an element is in viewport and should be displayed
    function is_slide_element_in_view() {
        $.each($slide_elements, function() {
            $slide_element = $(this);

            if(isElementInViewport($slide_element)) {
                $slide_element.removeClass('hide');
            }
        });
    }

    // Trigger the function on scroll, resize, and page load
    $(window).on('scroll resize', is_slide_element_in_view);
    $(window).trigger('scroll');
});